import React, { createRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./dashboard.css";
import Table from "../../components/Table/Table";
import apiUtil from "../../api/apiUtil";
import api from "../../api/api";
import InfoCard from "../../components/InfoCard/InfoCard";
import iconMember from "../../images/icons/DMembers.png";
import iconReservation from "../../images/icons/DReservation.png";
import iconRedemption from "../../images/icons/DRedemption.png";
import getToken from "../../pages/getToken";
import ChatItem from "../../components/ChatItem/chatItem";
import MemberChart from "../../components/MemberChart/memberChart";
import CustomButton from "../../components/CustomButton/custombutton";

const Dashboard = () => {

  const refReserveTable = createRef();
  const [dashboardInfo, setDashboardInfo] = useState({
    memberCount: 0,
    reservationCount: 0,
    redemptionCount: 0,
    monthCounts: [],
    onlineUsers: []
  });
  const [activeGiftPoint, setActiveGiftPoint] = useState(1);

  let brandId = localStorage.getItem("brandId");
  const getDashboardInfo = () => {
    api
      .get("Admin/GetDashboardInfo", { BrandId: brandId }, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setDashboardInfo(response.data.data);
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            alert(error);
          }
        )
      );
  };

  // console.log(dashboardInfo);
  // console.log(dashboardInfo.onlineUsers);

  const online_users = dashboardInfo.onlineUsers;

  const [redemptionList, setRedemptionList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [paramRedemption, setParamRedemption] = useState({
    rowLimit: 6,
    currentPage: 1,
    type: activeGiftPoint,
  });

  const clickActiveGiftPoint = (newTab) => {
    setParamRedemption({
      ...paramRedemption,
      type: newTab,
    });
    if (activeGiftPoint != newTab) {
      setActiveGiftPoint(newTab);
    } else {
      setActiveGiftPoint(0);
    }
  };


  const retrieveRedemptionList = (value = paramRedemption) => {
    api.post("Admin/GetRedeemListByAdmin", value, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setRedemptionList({
              isLoading: false,
              limit: response.data.data.rowLimit,
              data:
                response.data.data.data && response.data.data.data.length > 0
                  ? response.data.data.data
                  : [],
              total: response.data.data.totalRecords,
              page: response.data.data.paging,
            });
          } else {
            setRedemptionList({
              isLoading: false,
              grouping: false,
              limit: 0,
              data: [],
              total: 0,
              page: 0,
            });
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );
  };

  const [reserveList, setReserveList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });
  const [paramReserve, setParamReserve] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    filterDate: null,
  });

  const retrieveReserveList = (value = paramReserve) => {
    setParamReserve(value);
    setReserveList({
      ...reserveList,
      isLoading: true,
    });
    // console.log(value);

    api
      .post("Admin/GetReserveListByAdmin", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setReserveList({
                isLoading: false,
                limit: response.data.data.rowLimit,
                data:
                  response.data.data.data && response.data.data.data.length > 0
                    ? response.data.data.data
                    : [],
                total: response.data.data.totalRecords,
                page: response.data.data.paging,
              });
            } else {
              setReserveList({
                isLoading: false,
                grouping: false,
                limit: 0,
                data: [],
                total: 0,
                page: 0,
              });
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  useEffect(() => {
    getDashboardInfo();
    retrieveRedemptionList();
    retrieveReserveList();
  }, [paramRedemption, activeGiftPoint]);

  return (

    <div className="dashboard">
      <div className="content">
        <div className="CardList">
          <InfoCard
            title="Total Member"
            count={dashboardInfo.memberCount ? dashboardInfo.memberCount : 0}
            sale="+ 32.12%"
            icon={iconMember}
            iconWidth="24px"
          />
          <InfoCard
            title="Total Reservation"
            count={
              dashboardInfo.reservationCount
                ? dashboardInfo.reservationCount
                : 0
            }
            sale="+ 32.12%"
            icon={iconReservation}
            iconWidth="29px"
          />
          <InfoCard
            title="Total Reward"
            count={
              dashboardInfo.redemptionCount
                ? dashboardInfo.redemptionCount
                : 0
            }
            sale="+ 32.12%"
            icon={iconRedemption}
            iconWidth="26px"
          />
        </div>
        {/* Chart  */}
        <div className="member-chart">
          <MemberChart data={dashboardInfo.monthCounts} />
        </div>

        {/* Reservation List */}
        <div className="reservation">
          <div className="Actions space_between title_container">
            <h4 className="title_text m-0">Reservation List</h4>
            <Link to="/reserve">
              <button
                type="button"
                className="btnViewAll"
              >
                View All
              </button>
            </Link>
          </div>
          <div className="table_container reservation_table">
            <Table
              ref={refReserveTable}
              maxBodyHeight={"310px"}
              isLoading={reserveList.isLoading}
              grouping={reserveList.grouping}
              limit={reserveList.limit}
              page={reserveList.page}
              total={reserveList.total}
              data={reserveList.data}
              columns={[
                {
                  title: "Name",
                  render: (row) => {
                    if (row.name == null || row.name == "") {
                      return "Unknown";
                    }
                    return row.name;
                  },
                  width: "100px",
                },
                {
                  title: "PhoneNo",
                  render: (row) => {
                    return row.phone ? row.phone : '-';
                  },
                  width: "80px",
                },
                {
                  title: "RoomName",
                  render: (row) => {
                    return row.roomName ? row.roomName : '-';
                  },
                  width: "80px",
                },
                {
                  title: "Start Date",
                  render: (row) => {
                    return apiUtil.getDateShortMonthByUSFormat(
                      row.startDate
                    );
                  },
                  width: "120px",
                },
                {
                  title: "End Date",
                  render: (row) => {
                    return apiUtil.getDateShortMonthByUSFormat(
                      row.endDate
                    );
                  },
                  width: "120px",
                },
                {
                  title: "Status",
                  render: (row) => {
                    const getStatus = () => {
                      switch (row.status) {
                        case 0:
                          return {
                            statusName: "Cancelled",
                            statusClassName: "status-rejected",
                          };
                        case 1:
                          return {
                            statusName: "Pending",
                            statusClassName: "status-pending",
                          };
                        case 2:
                          return {
                            // statusName: "Approved",
                            statusName: "Accepted",
                            statusClassName: "status-approved",
                          };
                        case 3:
                          return {
                            statusName: "Rejected",
                            statusClassName: "status-rejected",
                          };
                        default:
                          return {};
                      }
                    };
                    return (
                      <div
                        className={` status-container ${getStatus().statusClassName
                          } `}
                      >
                        <div className="status-dot"></div>
                        {getStatus().statusName}
                      </div>
                    );
                  },
                  width: "120px",
                }
              ]}
            />
          </div>
        </div>
      </div>
      <div className="right_sidebar">
        {/* Member Redemption */}
        <div className="member_redemption">
          <div className="Actions space_between title_container">
            <h4 className="title_text">Member Rewards</h4>
            <Link to="/reward/customer">
              <button
                type="button"
                className="btnViewAll"
              >
                View All
              </button>
            </Link>
          </div>
          <div
            className={`table_container redemption_table ${redemptionList.total > 0 ? "" : "empty_table"
              }`}
          >
            <Table
              maxBodyHeight="364px"
              isLoading={redemptionList.isLoading}
              grouping={redemptionList.grouping}
              limit={redemptionList.total}
              page={redemptionList.page}
              total={redemptionList.total}
              data={redemptionList.data}
              columns={[
                {
                  title: "Name",
                  field: "customerName",
                  width: "100px",
                },
                {
                  title: "Branches",
                  render: (row) => {
                    if (row.branchName == null || row.branchName == "") {
                      return "-";
                    }
                    return row.branchName;
                  },
                  width: "100px",
                },
                {
                  title: "Reward Date",
                  render: (row) => {
                    if (row.redeemDate == null || row.redeemDate == "") {
                      return "-";
                    }
                    return apiUtil.getDateShortMonthFormat(row.redeemDate);
                  },
                  width: "100px",
                },
              ]}
            />
          </div>
          <div className="Actions button_list">
            <CustomButton
              text="Gift"
              addIcon={false}
              className={"btnAdd justify-content-end " + (activeGiftPoint === 1 ? "buttonActive" : "")}
              onClick={() => clickActiveGiftPoint(1)}
            />
            <CustomButton
              text="Coupon"
              addIcon={false}
              className={"btnAdd justify-content-end " + (activeGiftPoint === 2 ? "buttonActive" : "")}
              onClick={() => clickActiveGiftPoint(2)}
            />

          </div>
        </div>

        {/* Online Users */}
        <div className="online_users">
          <h4 className="title_text">Online Users</h4>
          <div className="online-container">
            {online_users && online_users.length > 0 ? (
              online_users.map((user) => (
                <ChatItem
                  key={user.id}
                  username={user.name}
                  user_image={user.image}
                />
              ))
            ) : (
              <p className="warning-text">No active users available.</p>
            )}
          </div>
        </div>
      </div>
    </div>

  );
};

export default Dashboard;
